<ion-header class="ion-no-border">
  <ion-toolbar class="header-toolbar">
    <ion-buttons slot="start">
      @if (leftSlotTpl(); as leftSlot) {
        <ng-container *ngTemplateOutlet="leftSlot"></ng-container>
      } @else if (enableBack()) {
        <ion-button class="back-btn" (click)="navigateBack()">
          <ion-icon slot="icon-only" name="arrow-back-outline"></ion-icon>
        </ion-button>
      }
    </ion-buttons>

    <div class="topnav-title-stack">
      @if (enableSelectFarm()) {
        <ion-button class="farm-label-btn" fill="clear" (click)="openFarmModal()">
          <span class="farm-label-text">{{ selectedFarm()?.farmName }}</span>
          <ion-icon name="chevron-down-outline"></ion-icon>
        </ion-button>
      }
      @if (resolvedTitleI18n()) {
        <div class="page-title">{{ resolvedTitleI18n() | i18n }}</div>
      }
    </div>

    @if (rightSlotTpl(); as rightSlot) {
      <ion-buttons slot="end">
        <ng-container *ngTemplateOutlet="rightSlot"></ng-container>
      </ion-buttons>
    }
  </ion-toolbar>

  <ng-content></ng-content>
</ion-header>
